module.exports = __webpack_public_path__ + "img/hzserive2.badf9eb5.jpg";